import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <Layout showFooter={false}>
      <div className="max-w-md mx-auto px-4 py-16 text-center" data-testid="payment-cancel-page">
        <div className="h-16 w-16 rounded-full bg-slate-100 flex items-center justify-center mx-auto"><XCircle className="h-8 w-8 text-slate-400" /></div>
        <h1 className="font-heading text-2xl font-bold text-[#0A192F] mt-6">Checkout canceled</h1>
        <p className="text-slate-500 mt-2">No charge was made. You can upgrade anytime.</p>
        <div className="flex gap-3 justify-center mt-8">
          <Button variant="outline" onClick={() => navigate("/dashboard")}>Dashboard</Button>
          <Button className="bg-amber-600 hover:bg-amber-700 text-white" onClick={() => navigate("/upgrade")}>Try Again</Button>
        </div>
      </div>
    </Layout>
  );
}
